import { useEffect } from 'react';
import { checkSession, SessionChangeEmitter } from 'src/platform/libby/session';

export const useSessionBootstrap = () => {
  useEffect(() => {
    const bootstrap = async () => {
      const { isLogged, user } = await checkSession();

      localStorage.setItem('userSigned', JSON.stringify(user));
      localStorage.setItem('profile', isLogged ? 'private' : 'public');

      SessionChangeEmitter.emitChange({ isLogged, user });
    };

    bootstrap();
  }, []);
};
